import { CSSProperties, useRef } from 'react'
import { Typography, styled } from '@mui/material'
import { RawContactMessage } from '@weblite/ts-action/message'
import { toHumanReadablePhone } from '$func/phone'
import { getUserAvatarText, getUserFirstName, useUser } from '$logic/users'
import { openUserProfile } from '$logic/router'
import { copyToClipboard } from '$func/clipboard'
import { showPhoneNumberSavedInMemorySnackbar } from '$comp/snackbars'
import { getUserImageUrl } from '$func/imageUrl'
import { stringToColor } from '$func/string-to-color'
import { AvatarBase } from '$common/avatar/avatar-base'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { MessageMenuIcon } from '../../components/menu-icon'

const Container = styled('div')`
  display: flex;
  position: relative;
  align-items: center;

  padding: 10px 10px 10px 32px;
  box-sizing: border-box;
  overflow: hidden;
`

const TextsContainer = styled('div')`
  flex-grow: 1;
  /* @noflip */
  margin-right: 10px;
  overflow: hidden;
  cursor: pointer;
`

export function Contact({
  attachment,
  statusComp,
  rootStyle = undefined,
  iid,
  roomId,
}: {
  attachment: RawContactMessage['attachment']
  statusComp: JSX.Element | null
  rootStyle?: CSSProperties
  iid: number
  roomId: string
}) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { firstname, lastname, phone, id } = attachment

  const { user } = useUser(id)

  const avatarBackgroundColor = stringToColor(getUserFirstName(user), user?.id)

  const containerRef = useRef<HTMLDivElement>(null)
  const onClick = async () => {
    if (user && id) openUserProfile(id)
    else {
      copyToClipboard(toHumanReadablePhone(phone, false))
      showPhoneNumberSavedInMemorySnackbar()
    }
  }
  return (
    <>
      <Container ref={containerRef} style={{ width: '280px', ...rootStyle }}>
        <AvatarBase
          src={getUserImageUrl(user)}
          size={AvatarSize.LG}
          sx={{ cursor: 'pointer' }}
          backgroundColor={avatarBackgroundColor}
          onClick={onClick}
        >
          {getUserAvatarText(user)}
        </AvatarBase>
        <TextsContainer onClick={onClick}>
          <Typography
            color="semiBlack"
            variant="messageBold"
            sx={{
              display: 'block',
              marginBottom: '5px',
            }}
            noWrap
          >
            {`${firstname ?? ''} ${lastname ?? ''}`}
          </Typography>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              overflow: 'hidden',
            }}
          >
            <Typography variant="caption1" noWrap sx={{ color: 'gray' }}>
              {toHumanReadablePhone(phone)}
            </Typography>
          </div>
        </TextsContainer>
        <MessageMenuIcon iid={iid} roomId={roomId} />
      </Container>
      {statusComp}
    </>
  )
}
